module.exports = __webpack_public_path__ + "img/photo-27.ef2be350.jpg";